import * as _ from "lodash-es";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./MonthlyOrdersWidget.scss";

type Props = {
    totalMonthlyOrders: any;
    inEditor?: boolean;
    removeWidget?: () => void;
};

export const MonthlyOrdersWidget = (props: Props) => {
    let totalMonthlyOrders = 0;

    // work around for API Update for 1.17.0 - TODO Remove after 1.17.0 deployment
    if (_.isNumber(props.totalMonthlyOrders)) {
        totalMonthlyOrders = props.totalMonthlyOrders;
    } else {
        totalMonthlyOrders = props.totalMonthlyOrders.order_count;
    }

    return (
        <div className={"MonthlyOrdersWidget col-12 widget .g-0s dashboard-widget " + (props.inEditor ? "in-editor" : "")}>
            {props.inEditor ? (
                <div className={""}>
                    <OwIconButton
                        iconClass={"fas fa-trash-alt"}
                        iconColorClass={"text-danger"}
                        fn={(e) => {
                            e?.preventDefault();
                            e?.stopPropagation();
                            props.removeWidget!();
                        }}
                    />
                </div>
            ) : null}
            <OwTitle tag={"h4"} title={"dashboard.monthly_orders"} />
            <div className="faded-orange number">{totalMonthlyOrders}</div>
            {props.inEditor ? (
                "View"
            ) : (
                <Link title={"orders"} to="/orders">
                    <OwLabel title={"view"} className={"pointer"} />
                </Link>
            )}
        </div>
    );
};
